// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "9bb601430a6b";
export const BUILD_VERSION_NUMBER = 8;
